import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=66179f6a"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66179f6a')) {
      api.createRecord('66179f6a', component.options)
    } else {
      api.reload('66179f6a', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=66179f6a", function () {
      api.rerender('66179f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/content/Loader.vue"
export default component.exports